import { NextPage } from 'next'
import { useEffect } from 'react'

import { useFocusActionState } from 'src/providers/FocusActionProvider'

import { Page } from 'src/components/layouts/Page'
import { DonateForm } from 'src/components/organisms/forms/DonateForm'

import { withAccountRequired } from 'src/utils/auth'

const Donate: NextPage = () => {
  const { setFocussedHeader: setFocus } = useFocusActionState()
  useEffect(() => {
    setFocus()
  }, [setFocus])

  return (
    <Page
      title='Donate a native tree'
      metaTitle='Donate a native tree'
      metaDescription="Donate a native tree for just $13 - native trees you donate will be matched to a planting project and we'll let you know where your tree will be planted."
    >
      <div className="max-w-3xl! mx-auto row min-h-dvh text-forestDeep [&_[role=radiogroup]_svg]:fill-lavenderBright! [&_.form-input-wrapper]:rounded-none! [&_.form-input-wrapper]:border-black! [&_select]:text-forestDeep! [&_select]:appearance-none [&_select]:bg-no-repeat [&_select]:pr-4 [&_select]:[background-position:right_center] [&_select]:[background-size:10px] [&_select]:[background-image:url('data:image/svg+xml,%3Csvg_xmlns=%22http://www.w3.org/2000/svg%22_width=%2210%22_height=%226%22%3E%3Cpath_d=%22M0_0l5_6_5-6z%22_fill=%22%2308441B%22/%3E%3C/svg%3E')]">
        <DonateForm />
      </div>
    </Page>
  )
}

export default withAccountRequired(Donate)
